import styled from 'styled-components';

export const Container = styled.div`
 width:auto;
`
export const Text = styled.span`
font-family: "Open Sans",sans-serif;
font-size: 12px;
line-height: 13px;
text-align: right;
color: #97A3B7;
opacity: 0.4;
`